module.exports = {
  "dof-slider": {
    "flexDirection": "column",
    "position": "relative"
  },
  "dof-slider-track": {
    "position": "relative"
  },
  "dof-slider-bar": {
    "position": "relative",
    "overflow": "hidden"
  },
  "dof-slider-bar--brand": {
    "backgroundColor": "#00a4f2"
  },
  "dof-slider-bar--purple": {
    "backgroundColor": "#995efc"
  },
  "dof-slider-bar--blue-purple": {
    "backgroundColor": "#6575ff"
  },
  "dof-slider-bar--blue": {
    "backgroundColor": "#29c3ff"
  },
  "dof-slider-bar--cyan": {
    "backgroundColor": "#00bdb2"
  },
  "dof-slider-bar--yellow": {
    "backgroundColor": "#ffaa10"
  },
  "dof-slider-bar--orange": {
    "backgroundColor": "#ffaa10"
  },
  "dof-slider-bar--orange-red": {
    "backgroundColor": "#f56428"
  },
  "dof-slider-bar--gray-offline": {
    "backgroundColor": "#7c879b"
  },
  "dof-slider-button": {
    "position": "absolute"
  },
  "@TRANSITION": {
    "button-scale": {
      "property": "transform",
      "duration": 300,
      "delay": 0
    }
  },
  "button-scale": {
    "transitionProperty": "transform",
    "transitionDuration": 300,
    "transitionDelay": 0,
    "transform": "scale(1)",
    "transform:active": "scale(1.5)"
  },
  "dof-slider-button-touching": {
    "transform": "scale(1.5)"
  },
  "dof-slider-scales": {
    "position": "relative",
    "marginTop": "16",
    "height": "24"
  },
  "dof-slider-thin-bar": {
    "position": "absolute"
  },
  "dof-slider-thin-bar-left": {
    "position": "absolute",
    "height": "4",
    "top": "0",
    "left": "0"
  },
  "dof-slider-thin-bar-right": {
    "position": "absolute",
    "height": "4",
    "top": "0",
    "right": "0"
  },
  "dof-slider-disabled-mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0
  },
  "hideButton": {
    "opacity": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6a86068c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-slider/index.vue
// module id = 505
// module chunks = 0 1